export function getInitials(name?: string | undefined) {
    if (!name) {
        return "U"
    }

    const nameParts = name.split(" ")
    const initials = nameParts
        .map((part) => part.charAt(0).toUpperCase())
        .join("")
        .slice(0, 2)
    return initials
}

export function getFirstName(name?: string | undefined) {
    if (!name) {
        return "User"
    }

    const nameParts = name.split(" ")
    return nameParts[0]
}
